/**
 * Scroll to element if it is not in view
 * @param offset
 */
export function scrollToElement(el?: HTMLElement, offset = 0) {
  if (!el) return;
  const { top } = el.getBoundingClientRect();
  if (top < offset) {
    const diff = top - offset;
    window.scrollBy({
      top: diff,
      behavior: 'smooth',
    });
  }
}
